import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { TechSurveyDetailPage } from '../tech-survey-detail/tech-survey-detail';
import { PostBoilerImagePage } from '../post-boiler-image/post-boiler-image';
import { RemedialSurveyPage } from '../remedial-survey/remedial-survey';
import { ElevationImageReportPage } from '../elevation-image-report/elevation-image-report';
import { UnderFloorImageReportPage } from '../underfloor-image-report/underfloor-image-report';
import { UnderFloorInstallImageReportPage } from '../underfloor-install-image-report/underfloor-install-image-report';
import { BoilerSurveyPage } from '../boiler-survey/boiler-survey';

import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
import * as Survey from 'survey-angular';
import { Http } from '@angular/http';
import { Geolocation } from '@ionic-native/geolocation';



@Component({
  selector: 'page-survey',
  templateUrl: 'survey.html',
})
export class SingleSurveyPage {
  errorMessage = '';
  surveys = new Array;
  survey : any = {}
  lat = '';
  long = '';
  property_id = 0;
  disableButton = false;
  contact = {self_surveyURL:'',customers_telephone:'',delivery_lastname:'',delivery_firstname:'',companyname:'',customer_id:0};
  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public loading: LoadingProvider,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    private geolocation: Geolocation,
    public alert: AlertProvider
  ) {
  }


ionViewWillEnter() {



}

showSurveyDetail(survey) {
  console.log("Go to Survey:",survey);
  if(survey.pagelink == "post-boiler-image")
  {
    this.navCtrl.push(PostBoilerImagePage, { 'data': survey, 'property_id': this.property_id });
  }
  else if (survey.pagelink == "elevation-image-report"){
    this.navCtrl.push(ElevationImageReportPage, { 'data': survey, 'property_id': this.property_id });
  }
  else if (survey.pagelink == "underfloor-image-report"){
    this.navCtrl.push(UnderFloorImageReportPage, { 'data': survey, 'property_id': this.property_id });
  }
  else if (survey.pagelink == "underfloor-install-image-report"){
    this.navCtrl.push(UnderFloorInstallImageReportPage, { 'data': survey, 'property_id': this.property_id });
  }
  else if (survey.pagelink == "boiler-survey-report"){
    this.navCtrl.push(BoilerSurveyPage, { 'data': survey, 'property_id': this.property_id });
  }
  else if (survey.pagelink == "remedial-image"){
    this.navCtrl.push(RemedialSurveyPage, { 'data': survey, 'property_id': this.property_id });
  }


  else{
  this.navCtrl.push(TechSurveyDetailPage, { 'data': survey, 'property_id': this.property_id });
  }
}

showLoader(){
  this.loading.show();
}

hideLoader(){
  this.loading.hide();
}

ngOnInit() {

  this.survey = this.navParams.get('data');

  console.log("Survey Details:",this.survey);
  this.property_id= this.survey.property_id;
    console.log("Property ID:",this.property_id);

    var self = this;

this.geolocation.getCurrentPosition().then(pos => {
  console.log("Got Geo" + pos.coords.latitude);
   this.lat = pos.coords.latitude.toFixed(6);
   this.long = pos.coords.longitude.toFixed(6);


}).catch(err => console.log(err));

  console.log("Customer ID:",this.shared.customerData.customers_id)
  var data = { ar_id: this.shared.customerData.customers_id,property_id:this.property_id };
  this.loading.show();
  this.shared.resetSurveyImages();  //Clear survey images if changing property
  this.http.post(this.config.url + 'getTechSurveysbyCustomer', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    this.surveys = data.data;
    let survey_images  = data.images;
    console.log("Survey:",this.surveys[0].survey_title);
    console.log("Survey Images:",survey_images);
    for (let image of survey_images) {
      console.log("Got Image Type:" + image.image_type + " with URL:" + image.image_url);

    if(image.image_type == 'gas_rate_image'){
        var length = this.shared.survey_images.gas_rate_image.push(image);
        console.log("Images:",this.shared.survey_images.gas_rate_image);

      }
      else if(image.image_type == 'gas_gauge_working_pressure_image')
      {
        var length = this.shared.survey_images.gas_gauge_working_pressure_image.push(image);
      }
      else if(image.image_type == 'trv_installed')
      {
        var length = this.shared.survey_images.trv_installed.push(image);
      }
      else if (image.image_type == 'analyser_in_flue_image'){
        var length = this.shared.survey_images.analyser_in_flue_image.push(image);
      }
      else if (image.image_type == 'underneath_boiler_image'){
        var length = this.shared.survey_images.underneath_boiler_image.push(image);
      }
      else if(image.image_type == 'front_elevation_image'){
        var length = this.shared.survey_images.front_elevation_image.push(image);
      }
      else if(image.image_type == 'rear_elevation_image'){
        var length = this.shared.survey_images.rear_elevation_image.push(image);
      }
      else if(image.image_type == 'right_elevation_image'){
        var length = this.shared.survey_images.right_elevation_image.push(image);
      }
      else if(image.image_type == 'left_elevation_image'){
        var length = this.shared.survey_images.left_elevation_image.push(image);
      }
      else if(image.image_type == 'new_flue_internal_image'){
        var length = this.shared.survey_images.new_flue_internal_image.push(image);
      }
      else if(image.image_type == 'new_flue_image'){
        var length = this.shared.survey_images.new_flue_image.push(image);
      }
      else if(image.image_type == 'installed_radiator_image'){
        var length = this.shared.survey_images.installed_radiator_image.push(image);
      }
      else if(image.image_type == 'main_entrance_elevation_image'){
        var length = this.shared.survey_images.main_entrance_elevation_image.push(image);
      }
      else if(image.image_type == 'new_data_badge_image'){
        var length = this.shared.survey_images.new_data_badge_image.push(image);
      }
      else if(image.image_type == 'new_boiler_on_wall_image'){
        var length = this.shared.survey_images.new_boiler_on_wall_image.push(image);
      }
      else if(image.image_type == 'new_flue_side_image'){
        var length = this.shared.survey_images.new_flue_side_image.push(image);
      }
      else if(image.image_type == 'condense_termination_image'){
        var length = this.shared.survey_images.condense_termination_image.push(image);
      }
      else if(image.image_type == 'condense_pipe_thru_wall'){
        var length = this.shared.survey_images.condense_pipe_thru_wall.push(image);
      }
      else if(image.image_type  == 'fused_spur_image'){
        var length = this.shared.survey_images.fused_spur_image.push(image);
      }
      else if(image.image_type  == 'property_detachment_image'){
        var length = this.shared.survey_images.property_detachment_image.push(image);
      }
      else if(image.image_type  == 'wall_thickness_image'){
        var length = this.shared.survey_images.wall_thickness_image.push(image);
      }
      else if(image.image_type  == 'ufi_measurements_image'){
        var length = this.shared.survey_images.ufi_measurements_image.push(image);
      }
      else if(image.image_type  == 'ufi_general_image'){
        var length = this.shared.survey_images.ufi_general_image.push(image);
      }
      else if(image.image_type  == 'ufi_access_image'){
        var length = this.shared.survey_images.ufi_access_image.push(image);
      }
      else if(image.image_type  == 'ufi_clear_space_image'){
        var length = this.shared.survey_images.ufi_clear_space_image.push(image);
      }
      else if(image.image_type  == 'ufi_pre_install'){
        var length = this.shared.survey_images.ufi_pre_install.push(image);
      }
      else if(image.image_type  == 'ufi_mid_install'){
        var length = this.shared.survey_images.ufi_mid_install.push(image);
      }
      else if(image.image_type  == 'ufi_install_complete'){
        var length = this.shared.survey_images.ufi_install_complete.push(image);
      }
      else if(image.image_type  == 'ufi_vents_clear'){
        var length = this.shared.survey_images.ufi_vents_clear.push(image);
      }
      else if(image.image_type  == 'ufi_damp_meter_reading'){
        var length = this.shared.survey_images.ufi_damp_meter_reading.push(image);
      }
      else if(image.image_type  == 'ufi_measurements_pica'){
        var length = this.shared.survey_images.ufi_measurements_pica.push(image);
      }
      else if(image.image_type  == 'vent_bricks_image'){
        var length = this.shared.survey_images.vent_bricks_image.push(image);
      }
      else if(image.image_type  == 'extractors_image'){
        var length = this.shared.survey_images.extractors_image.push(image);
      }
      else if(image.image_type  == 'doors_image'){
        var length = this.shared.survey_images.doors_image.push(image);
      }
      else if(image.image_type  == 'windows_image'){
        var length = this.shared.survey_images.windows_image.push(image);
      }
      else if(image.image_type  == 'bedrooms_image'){
        var length = this.shared.survey_images.bedrooms_image.push(image);
      }
      else if(image.image_type  == 'trv_images'){
        var length = this.shared.survey_images.trv_images.push(image);
      }
      else if(image.image_type  == 'radiators_image'){
        var length = this.shared.survey_images.radiators_image.push(image);
      }
      else if(image.image_type  == 'flue_external_image'){
        var length = this.shared.survey_images.flue_external_image.push(image);
      }
      else if(image.image_type  == 'flue_internal_image'){
        var length = this.shared.survey_images.flue_internal_image.push(image);
      }
      else if(image.image_type  == 'gas_meter_images'){
        var length = this.shared.survey_images.gas_meter_images.push(image);
      }
      else if(image.image_type  == 'full_boiler_images'){
        var length = this.shared.survey_images.full_boiler_images.push(image);
      }
      else if(image.image_type  == 'co_alarm_image'){
        var length = this.shared.survey_images.co_alarm_image.push(image);
      }
      else if(image.image_type  == 'existing_boiler_data_badge'){
        var length = this.shared.survey_images.existing_boiler_data_badge.push(image);
      }
      else if(image.image_type  == 'existing_boiler_flue_internal'){
        var length = this.shared.survey_images.existing_boiler_flue_internal.push(image);
      }
      else if(image.image_type  == 'existing_boiler_flue_external'){
        var length = this.shared.survey_images.existing_boiler_flue_external.push(image);
      }
      else if(image.image_type  == 'existing_boiler_image'){
        var length = this.shared.survey_images.existing_boiler_image.push(image);
      }
      else if(image.image_type  == 'boiler_off_wall_image'){
        var length = this.shared.survey_images.boiler_off_wall_image.push(image);
      }
      else if(image.image_type  == 'proof_of_address_image'){
        var length = this.shared.survey_images.proof_of_address_image.push(image);
      }
      else if(image.image_type  == 'heating_controls_image'){
        var length = this.shared.survey_images.heating_controls_image.push(image);
      }
      else if(image.image_type  == 'dpc_internal_external_image'){
        var length = this.shared.survey_images.dpc_internal_external_image.push(image);
      }
      else if(image.image_type  == 'new_heating_controls_image'){
        var length = this.shared.survey_images.new_heating_controls_image.push(image);
      }
      else if(image.image_type  == 'remedial-image'){
        var length = this.shared.survey_images.remedial_image.push(image);
      }
      else if(image.image_type   == 'bypass_rad_image'){
        var length  = this.shared.survey_images.bypass_rad_image.push(image);

      }
      else if(image.image_type   == 'loft_suitable_piv'){
        var length  = this.shared.survey_images.loft_suitable_piv.push(image);

      }
      else if(image.image_type   == 'vents_external_image'){
        var length  = this.shared.survey_images.vents_external_image.push(image);

      }
      else if(image.image_type   == 'vents_internal_image'){
        var length  = this.shared.survey_images.vents_internal_image.push(image);

      }

    }





});

}
}



// WEBPACK FOOTER //
// ./src/pages/survey/survey.ts